export function serializeMonthDate(date: Date) {
  return `${date.getFullYear()}-${(date.getUTCMonth() + 1)
    .toString()
    .padStart(2, "0")}`;
}
